<template>
  <div>
    <div
      class="card shadow table-container vld-parent"
      ref="list_pending_reservations"
    >
      <div class="card-header bg-transparent">
        <h3 class="mb-0">
          <i class="fas fa-user-clock mr-1"></i> Reservas pendentes
          <base-button
            v-if="pendingReservations.length === initialLimit"
            size="sm"
            class="float-right"
            type="default"
            @click="getPendingReservations()"
            >Ver tudo</base-button
          >
        </h3>
      </div>

      <div class="table-responsive">
        <base-table
          thead-classes="thead-light"
          class="table align-items-center table-flush"
          tbody-classes="list"
          :data="pendingReservations"
          type="hover"
        >
          <template slot="columns">
            <th>Status</th>
            <th>Espaço</th>
            <th>Colaborador</th>
            <th>Tipo da reserva</th>
            <th>Data</th>
            <th>Horário</th>
            <th>Ações</th>
          </template>

          <template slot-scope="{ row }">
            <td>
              <badge :type="reservationStatus[row.status].type">{{
                reservationStatus[row.status].name
              }}</badge>
            </td>
            <th scope="row">
              {{ row.room.name }}
            </th>
            <td>
              <router-link
                :to="
                  `/empresa/colaboradores/${row.collaborator.user_id}/editar`
                "
                class="btn btn-link p-0 m-0"
                title="Ver colaborador"
              >
                {{ row.collaborator.name }}
              </router-link>
            </td>
            <td>{{ row.type }}</td>
            <td>
              {{ formatDate(row.start_date, "L")
              }}{{
                row.end_date ? ` até ${formatDate(row.end_date, "L")}` : ""
              }}
            </td>
            <td>{{ row.start_hour }} até {{ row.end_hour }}</td>
            <td>
              <base-button
                @click="handleViewReservation(row.id)"
                type="info"
                size="sm"
                title="Gerenciar reserva"
                >Gerenciar</base-button
              >
            </td>
          </template>
        </base-table>
        <p
          v-if="empty.pendingReservations"
          class="text-center text-warning mt-3"
        >
          Não há reservas pendentes no momento
        </p>
      </div>
    </div>
    <div
      class="card shadow table-container vld-parent mt-4"
      ref="list_confirmed_reservations"
    >
      <div class="card-header bg-transparent">
        <h3 class="mb-0">
          <i class="fas fa-user-check mr-1"></i> Reservas confirmadas
          <base-button
            v-if="confirmedReservations.length === initialLimit"
            size="sm"
            class="float-right"
            type="default"
            @click="getConfirmedReservation()"
            >Ver tudo</base-button
          >
        </h3>
      </div>

      <div class="table-responsive">
        <base-table
          thead-classes="thead-light"
          class="table align-items-center table-flush"
          tbody-classes="list"
          :data="confirmedReservations"
          type="hover"
        >
          <template slot="columns">
            <th>Status</th>
            <th>Espaço</th>
            <th>Colaborador</th>
            <th>Tipo da reserva</th>
            <th>Data</th>
            <th>Horário</th>
            <th>Ações</th>
          </template>

          <template slot-scope="{ row }">
            <td>
              <badge :type="reservationStatus[row.status].type">{{
                reservationStatus[row.status].name
              }}</badge>
            </td>
            <th scope="row">{{ row.room.name }}</th>
            <td>
              <router-link
                :to="
                  `/empresa/colaboradores/${row.collaborator.user_id}/editar`
                "
                class="btn btn-link p-0 m-0"
                title="Ver colaborador"
              >
                {{ row.collaborator.name }}
              </router-link>
            </td>
            <td>{{ row.type }}</td>
            <td>
              {{ formatDate(row.start_date, "L")
              }}{{
                row.end_date ? ` até ${formatDate(row.end_date, "L")}` : ""
              }}
            </td>
            <td>{{ row.start_hour }} até {{ row.end_hour }}</td>
            <td>
              <base-button
                @click="handleViewReservation(row.id)"
                type="info"
                size="sm"
                title="Gerenciar reserva"
                >Gerenciar</base-button
              >
            </td>
          </template>
        </base-table>
        <p
          v-if="empty.confirmedReservations"
          class="text-center text-warning mt-3"
        >
          Não há reservas confirmadas no momento
        </p>
      </div>
    </div>
    <div
      class="card shadow table-container vld-parent mt-4"
      ref="list_canceled_reservations"
    >
      <div class="card-header bg-transparent">
        <h3 class="mb-0">
          <i class="fas fa-user-times mr-1"></i> Reservas canceladas
          <base-button
            v-if="canceledReservations.length === initialLimit"
            size="sm"
            class="float-right"
            type="default"
            @click="getCanceledReservations()"
            >Ver tudo</base-button
          >
        </h3>
      </div>

      <div class="table-responsive">
        <base-table
          thead-classes="thead-light"
          class="table align-items-center table-flush"
          tbody-classes="list"
          :data="canceledReservations"
          type="hover"
        >
          <template slot="columns">
            <th>Status</th>
            <th>Espaço</th>
            <th>Colaborador</th>
            <th>Tipo da reserva</th>
            <th>Data</th>
            <th>Horário</th>
            <th>Ações</th>
          </template>

          <template slot-scope="{ row }">
            <td>
              <badge :type="reservationStatus[row.status].type">{{
                reservationStatus[row.status].name
              }}</badge>
            </td>
            <th scope="row">{{ row.room.name }}</th>
            <td>
              <router-link
                :to="
                  `/empresa/colaboradores/${row.collaborator.user_id}/editar`
                "
                class="btn btn-link p-0 m-0"
                title="Ver colaborador"
              >
                {{ row.collaborator.name }}
              </router-link>
            </td>
            <td>{{ row.type }}</td>
            <td>
              {{ formatDate(row.start_date, "L")
              }}{{
                row.end_date ? ` até ${formatDate(row.end_date, "L")}` : ""
              }}
            </td>
            <td>{{ row.start_hour }} até {{ row.end_hour }}</td>
            <td>
              <base-button
                @click="handleViewReservation(row.id)"
                type="info"
                size="sm"
                title="Gerenciar reserva"
                >Gerenciar</base-button
              >
            </td>
          </template>
        </base-table>
        <p
          v-if="empty.canceledReservations"
          class="text-center text-warning mt-3"
        >
          Não há reservas canceladas no momento
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "reservas-table",
  data() {
    return {
      pendingReservations: [],
      confirmedReservations: [],
      canceledReservations: [],
      reservationStatus: {
        pending: {
          name: "Pendente",
          type: "primary"
        },
        confirmed: {
          name: "Confirmada",
          type: "success"
        },
        canceled: {
          name: "Cancelada",
          type: "danger"
        }
      },
      initialLimit: 10,
      empty: {
        pendingReservations: "",
        confirmedReservations: "",
        canceledReservations: ""
      }
    };
  },
  async mounted() {
    this.getPendingReservations(`&limit=${this.initialLimit}`);
    this.getConfirmedReservation(`&limit=${this.initialLimit}`);
    this.getCanceledReservations(`&limit=${this.initialLimit}`);
  },
  methods: {
    async getPendingReservations(params = "") {
      this.loadReservations(
        `filter=pending${params}`,
        "pendingReservations",
        this.$refs.list_pending_reservations,
        "as reservas pendentes"
      );
    },
    async getConfirmedReservation(params = "") {
      this.loadReservations(
        `filter=confirmed${params}`,
        "confirmedReservations",
        this.$refs.list_confirmed_reservations,
        "as reservas confirmadas"
      );
    },
    async getCanceledReservations(params = "") {
      this.loadReservations(
        `filter=canceled${params}`,
        "canceledReservations",
        this.$refs.list_canceled_reservations,
        "as reservas canceladas"
      );
    },
    async loadReservations(getParams, targetObjName, loaderRef, errorMsg) {
      this.empty[targetObjName] = false;
      const loader = this.$loading.show({
        container: loaderRef,
        width: 90,
        height: 90
      });
      try {
        const { data } = await api.get(`/company/reservations?${getParams}`);
        if (data.length) this[targetObjName] = data;
        else this.empty[targetObjName] = true;
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar ${errorMsg}`);
      }
    },
    handleViewReservation(reservationId) {
      this.$router.push(
        `/empresa/espacos/reservas/${reservationId}/visualizar`
      );
    }
  }
};
</script>
<style scoped>
.text-seagreen {
  color: seagreen;
}
</style>
